import React from 'react';
import { Row } from 'antd';

import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import ParListSelect from 'components/ParListSelect';

const TabDocument = () => (
  <Row gutter={16}>
    <FormInput col xs={24} lg={8} name="parvalue" comcode='docstatusreason' rules={[{required:true}]}>
      <ParListSelect parcode="DOCSTREAS" />
    </FormInput>
    <FormInput col xs={24} lg={16} name="comment" comcode="docstatuscomment" rules={[{required:true}]}>
      <TextArea rows={4}></TextArea>
    </FormInput>
  </Row>
);

export default TabDocument;
